



























import { computed, defineComponent, ref, watch } from "@vue/composition-api";

import store from "@/store/root";
import EvidencesList from "@/components/EvidencesList.vue";
import LoadingOverlay from "@/tools/msa/components/LoadingOverlay.vue";

export default defineComponent({
  name: "LiveCard",
  components: { LoadingOverlay, EvidencesList },
  setup() {
    const term = ref<string>("");
    const terms = ref<string[]>([]);
    const isLoading = ref<boolean>(false);

    const evidences = computed(() =>
      (store.state as any).evidences.list.filter(
        (evidence: any) => evidence.type === "custom"
      )
    );

    const add = () => {
      terms.value.push(term.value);
      term.value = "";
    };

    watch(
      () => terms.value,
      () => {
        isLoading.value = true;

        store
          .dispatch("iclive/update", [...new Set([...terms.value].sort())])
          .finally(() => (isLoading.value = false));
      }
    );

    const onRemoved = (evidence: { desc: string }) => {
      terms.value = terms.value.filter(term => term !== evidence.desc);
    };

    return { isLoading, term, terms, evidences, onRemoved, add };
  }
});
